import { useEffect, useState, useCallback } from "react";

export function useSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
    isDesktop: undefined,
  });

  useEffect(() => {
    // only execute all the code below in client side
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isDesktop: window.innerWidth > 768,
      });
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize.isDesktop;
}

// export function useSize(isMobile) {
//   const [isDesktop, setIsDesktop] = useState(false);

//   const updateTarget = useCallback((e) => {
//     if (e.matches) {
//       setIsDesktop(true);
//     } else {
//       setIsDesktop(false);
//     }
//   }, []);

//   useEffect(() => {
//     const media = window.matchMedia(`(min-width: 769px)`);
//     if (media.addEventListener) {
//       media.addEventListener("change", updateTarget);
//     } else {
//       // compatibility for browser that dont have addEventListener
//       media.addListener(updateTarget);
//     }
//     // Check on mount (callback is not called until a change occurs)
//     if (media.matches) {
//       setIsDesktop(true);
//     }
//     if (media.removeEventListener) {
//       return () => media.removeEventListener("change", updateTarget);
//     } else {
//       // compatibility for browser that dont have removeEventListener
//       return () => media.removeListener(updateTarget);
//     }
//   }, []);

//   return isDesktop;
// }
